"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ClearSelections = function ClearSelections(_ref) {
  var onClick = _ref.onClick,
    allOptionsSelected = _ref.allOptionsSelected;
  var clearAllClass = function clearAllClass() {
    return (0, _classnames["default"])({
      'clear-all': true,
      'has-border': !allOptionsSelected
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: clearAllClass()
  }, /*#__PURE__*/_react["default"].createElement("a", {
    role: "button",
    onClick: onClick,
    tabIndex: 0
  }, "Clear All"));
};
ClearSelections.propTypes = {
  allOptionsSelected: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ClearSelections;